import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Wichita, KS?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Wichita can take 2–6 months, especially during busy travel seasons. For McConnell AFB families with PCS orders, Spirit AeroSystems engineers with overseas assignments, and WSU students with study-abroad deadlines, that timeline is simply not viable.",
  },
  {
    q: "Can McConnell AFB families get an expedited passport for PCS orders?",
    a: "Absolutely. McConnell AFB families are one of our most common client types in Wichita. PCS orders to Ramstein, Yokota, Mildenhall, or other overseas bases have fixed report dates. We process expedited passports for military families with processing as fast as 24 hours. Standard mail through a Wichita post office would take months — far too slow for military timelines.",
  },
  {
    q: "What if I'm a Spirit AeroSystems or Textron employee with a last-minute overseas assignment?",
    a: "This is a very common scenario in the Air Capital. Aerospace quality investigations, supplier audits, and executive meetings in Toulouse, São José dos Campos, or Montreal are scheduled on short notice with fixed dates. You cannot reschedule a defect investigation because your passport expired. We process expedited renewals and new applications for aerospace travelers with options as fast as 2–9 business days.",
  },
  {
    q: "Can WSU students get a passport fast for study abroad?",
    a: "Yes. Wichita State University students are frequent clients. Study-abroad program deadlines often leave students with as little as 4–6 weeks before orientation. First-time applicants (many college students) require an in-person acceptance clerk visit. We guide WSU students through the exact location, forms, and timeline so they do not miss their program orientation in Europe, Latin America, or Asia.",
  },
  {
    q: "How quickly can travelers in Andover, Derby, Haysville, or Goddard receive an expedited passport?",
    a: "Travelers in these Sedgwick County communities have the same access to our expedited services as Wichita residents. Since we operate remotely, your physical location in South Central Kansas does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients in the Wichita metro area receive their passports within 2–9 business days.",
  },
  {
    q: "Can Koch Industries employees get an expedited passport for international business travel?",
    a: "Yes — Koch Industries professionals are well within our service area. Whether you are attending a board meeting in London, a trade conference in Singapore, or a subsidiary visit in Mumbai, we make the renewal or new application process straightforward. You do not need to drive to Dallas for a passport agency appointment. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Wichita travelers start online and ship their documents via overnight courier. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Wichita metro area or South Central Kansas. No office visit needed for the vast majority of services.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function WichitaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Wichita and South Central Kansas travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}